import { render, staticRenderFns } from "./goodsFillInfo.vue?vue&type=template&id=84f7867e&scoped=true&"
import script from "./goodsFillInfo.vue?vue&type=script&lang=js&"
export * from "./goodsFillInfo.vue?vue&type=script&lang=js&"
import style0 from "./goodsFillInfo.vue?vue&type=style&index=0&id=84f7867e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f7867e",
  null
  
)

export default component.exports